import { Truck, CreditCard, Headphones, Shield } from "lucide-react";
import { cn } from "@/lib/utils";

const BenefitsBanner = () => {
  const benefits = [
    {
      icon: Truck,
      title: "Envío a todo el país",
      description: "Recibí tus productos donde estés",
    },
    {
      icon: CreditCard,
      title: "Múltiples formas de pago",
      description: "Tarjeta, transferencia o efectivo",
    },
    {
      icon: Headphones,
      title: "Asesoría experta",
      description: "Te ayudamos a elegir lo mejor",
    },
    {
      icon: Shield,
      title: "Garantía incluida",
      description: "Todos los productos con garantía",
    },
  ];

  return (
    <section className="bg-primary text-white py-4">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {benefits.map((benefit) => (
            <div 
              key={benefit.title}
              className="flex items-center gap-3"
            >
              <div className={cn(
                "w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0",
                "bg-white/20"
              )}>
                <benefit.icon className="h-5 w-5" />
              </div>
              <div className="hidden sm:block">
                <p className="font-semibold text-sm">{benefit.title}</p>
                <p className="text-xs text-white/80">{benefit.description}</p>
              </div>
              <p className="sm:hidden font-medium text-xs">{benefit.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsBanner;
